import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { weblogger } from './_weblogger';
/**
 * 采用V2上报为CLICK事件
 *
 * @param action // 元素标识，需在埋点管理平台注册，否则无法在 App 分析平台查看数据,【必填】
 * @param params // 元素补充参数，需在埋点管理平台注册，否则无法在 App 分析平台作为筛选维度查数,【选填】
 */
var sendImmediatelyClick = function sendImmediatelyClick(action, params) {
  weblogger && weblogger.sendImmediately('CLICK', {
    action: action,
    type: 'USER_OPERATION',
    params: params
  });
};

/**
 * 上报TASK事件
 *
 * @param action // 元素标识，需在埋点管理平台注册，否则无法在 App 分析平台查看数据,【必填】
 * @param taskEvent
 * @param extraParams
 */
var sendImmediatelyTask = function sendImmediatelyTask(action, taskEvent, extraParams) {
  weblogger && weblogger.sendImmediately(taskEvent || 'CLICK', _objectSpread(_objectSpread({
    type: 'STAY_LENGTH_STAT_EVENT',
    status: 'SUCCESS'
  }, extraParams), {}, {
    action: action
  }));
};

/**
 * 上报元素曝光事件
 *
 * @param action // 元素标识，需在埋点管理平台注册，否则无法在 App 分析平台查看数据,【必填】
 * @param params // 元素补充参数，需在埋点管理平台注册，否则无法在 App 分析平台作为筛选维度查数,【选填】
 */
var sendImmediatelyShow = function sendImmediatelyShow(action, params) {
  weblogger && weblogger.sendImmediately('SHOW', {
    action: action,
    params: params
  });
};

/**
 * 上报自定义事件
 *
 * @param action // 元素标识，需在埋点管理平台注册，否则无法在 App 分析平台查看数据,【必填】
 * @param params // 元素补充参数，需在埋点管理平台注册，否则无法在 App 分析平台作为筛选维度查数,【选填】
 */
var sendImmediatelyCustom = function sendImmediatelyCustom(action, params) {
  weblogger && weblogger.sendImmediately('CUSTOM', {
    key: action,
    value: params
  });
};
export { sendImmediatelyClick, sendImmediatelyShow, sendImmediatelyTask, sendImmediatelyCustom };